import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PathInfoMultilingualFragment = { id: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, sourceContentSyncedAt?: string | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null, jobScheduleId?: string | null }> | null, sourceContent?: { id: string, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null } | {} | null };


export type PathInfoMultilingualFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PathMultilingualInfoQueryVariables = Types.Exact<{
  pathId: Types.Scalars['String']['input'];
}>;


export type PathMultilingualInfoQuery = { content?: { id: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, sourceContentSyncedAt?: string | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null, jobScheduleId?: string | null }> | null, sourceContent?: { id: string, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum }> | null } | {} | null } | {} | null };

export const PathInfoMultilingualFragmentDoc = /*#__PURE__*/ gql`
    fragment PathInfoMultilingual on PathContentType {
  id
  type
  status
  lastContentEditTimeAt
  languageType
  defaultLanguageType
  languageConfigs {
    contentId
    languageType
    jobStatus
    jobScheduleId
  }
  isLocalizedContent
  sourceContent {
    ... on PathContentType {
      id
      lastContentEditTimeAt
      languageType
      languageConfigs {
        contentId
        languageType
      }
      defaultLanguageType
    }
  }
  sourceContentSyncedAt
}
    `;
export const PathMultilingualInfoDocument = /*#__PURE__*/ gql`
    query pathMultilingualInfo($pathId: String!) {
  content(filters: {id: $pathId}) {
    ... on PathContentType {
      ...PathInfoMultilingual
    }
  }
}
    ${PathInfoMultilingualFragmentDoc}`;

export function usePathMultilingualInfoQuery(options: Omit<Urql.UseQueryArgs<PathMultilingualInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<PathMultilingualInfoQuery, PathMultilingualInfoQueryVariables>({ query: PathMultilingualInfoDocument, ...options });
};